<template>
    <div v-loading="pageLoading">
        <el-form :model="formData" ref="formData" label-position="top" size="medium">
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="type" label="广告位：" :rules="[{ required: true, message: '请选择广告位' }]">
                        <el-select v-model="formData.type" :disabled="id ? true : false" placeholder="请选择">
                            <el-option label="演出详情页" :value="1"></el-option>
                            <el-option label="众筹详情页" :value="2"></el-option>
                            <el-option label="周边详情页" :value="3"></el-option>
                            <el-option label="APP首页Banner下方" :value="4"></el-option>
                            <el-option label="APP我的页面" :value="5"></el-option>
                            <el-option label="订单详情页" :value="6"></el-option>
                            <el-option label="弹窗广告" :value="7"></el-option>
							<el-option label="首页下拉广告" :value="9"></el-option>
							<el-option label="搜索页广告" :value="10"></el-option>
							<el-option label="一起看现场广告位" :value="11"></el-option>
                            <!-- <el-option label="WAP弹窗广告" :value="8"></el-option> -->
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="name" label="广告名称：" :rules="[{ required: true, message: '请填写广告名称' }]">
                        <span slot="label">
                            广告名称：
                            <small><span class="el-icon-warning"></span> 广告名称不会展示给用户，仅用于内部辨识和管理</small>
                        </span>
                        <el-input placeholder="请填写广告名称" v-model.trim="formData.name" maxlength="40"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <type-1 v-if="formData.type == 1" :form-data.sync="formData" :validateBindIds="validateBindIds" @clearValidate="clearValidate" :reFresh="reFresh"></type-1>
            <type-236 v-else-if="formData.type == 2 || formData.type == 3 || formData.type == 6" :form-data.sync="formData" :validateBindIds="validateBindIds"></type-236>
            <type-4510 v-else-if="formData.type == 4 || formData.type == 5 || formData.type == 10  || formData.type == 11" :form-data.sync="formData" :city-options="cityOptions"></type-4510>
            <type-78 v-else-if="formData.type == 7 " :form-data.sync="formData" :city-options="cityOptions"></type-78>
			<type-9 v-else-if="formData.type == 9 " :form-data.sync="formData" :city-options="cityOptions"></type-9>

            <el-form-item class="MT20">
                <el-button @click="$router.go(-1)">返回</el-button>
                <el-button type="primary" @click="onSubmit" :loading="btnLoading">确认提交</el-button>
                <el-button v-if="this.id" type="danger" @click="del">删除</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Type1 from './components/type1.vue'
import Type236 from './components/type236.vue'
import Type4510 from './components/type4510.vue'
import Type78 from './components/type78.vue'
import Type9 from './components/type9.vue'
export default {
    components: { Type1, Type236, Type4510, Type78,Type9},
    data() {
        return {
            id: this.$route.params.id,
			timeCalendar:this.$route.params.time,
            cityOptions: [],			
            formData: {
                name: '',
                type: 1,
                content: '',
                title: '',
                isBind: 1,
                bindIds: '',
                time1: [],
				time2: [],
				time3: [],
                showEndDate: '',
                showStartDate: '',
                showFrequency: 1,
                showUserType: 0,
                link: '',
                imgPath: '',
				imgPathWap:'',
                cityCodes: '',
                adType: 1, // 广告类型 1：文字 2：图片 3：文字弹窗 4：图片弹窗
                buttonContent: '',
                isShowButton: 0,
                closeCountDown: 0,
				cityType:0,
				cityCodeAndNameVos:[],
                aliLink:'',
                aliLinkAppid: '',
                wxLink: '',
                wxLinkAppid: '',
            },
            btnLoading: false,
            pageLoading: false,
            reFresh: false
        };
    },
    computed: {

    },
    mounted() {
        if (this.id) {
            this.getDetail();
        }else{
            this.reFresh = true;
        }
		if (this.timeCalendar){
			this.formData.time1 = [this.timeCalendar + ' 00:00:00' || '', this.timeCalendar + ' 23:59:59' || ''];			
		}
    },
    methods: {
        //获取详情
        async getDetail() {
            this.pageLoading = true;
            const response = await this.$request({
                url: "/advertising/info",
                method: "POST",
                params: { id: this.id },
            });
            const { msg, state, result } = response.data;
            this.pageLoading = false;

            if (state != 1){
                this.reFresh = true;
                return this.$message.error(msg || "请求失败");
            } 

            if(result.cityCodeAndNameVos && result.cityCodeAndNameVos.length > 0 && ( result.type != 4 || result.type != 5  ) ) {
                const cityCodes = []
                this.cityOptions = result.cityCodeAndNameVos.map(city => {
                    cityCodes.push(city.cityCode);
                    return {value: city.cityCode, label: city.cityName}
                });
                result.cityCodes = cityCodes;
            }		
			
            this.formData = {
                ...this.formData,
                ...result,
                // adType: result.type === 1 && result.imgPath ? 2 : 1,
                time1: result.showEndDate && result.showStartDate ? [result.showStartDate, result.showEndDate] : [],				
				time2: result.firstShowStartDate && result.firstShowEndDate ? [result.firstShowStartDate, result.firstShowEndDate] : [],
				time3: result.secondShowStartDate && result.secondShowEndDate ? [result.secondShowStartDate, result.secondShowEndDate] : [],
            };
            
            this.reFresh = true;
        },
        //验证绑定对象id
        validateBindIds(rule, value, callback) {
            if (this.formData.isBind === 0) return callback();
            if (!value) return callback(new Error('绑定对象ID不能为空'));
            if (!/^[0-9,，]+$/.test(value)) return callback(new Error('请填写正确的绑定对象格式'));
            return callback();
        },
        //清除验证
        clearValidate(){
            this.$nextTick(() => {
                this.$refs.formData.clearValidate();
            })
        },
		 // 判断时间段是否有交集
		  hasOverlap(range1, range2) {
		    const [s1, e1] = range1.map(d => new Date(d).getTime());
		    const [s2, e2] = range2.map(d => new Date(d).getTime());
		    return Math.max(s1, s2) < Math.min(e1, e2);
		  },
        //表单提交
        onSubmit() {
			const _form = {...this.formData}
			//如果type是9的话，三个时间段不能有交集
			if( _form.type === 9 ){
				const ranges = [_form.time1];
				[_form.time2, _form.time3].forEach(t => {
					if (t && t.length === 2) ranges.push(t);
				});
				for (let i = 0; i < ranges.length; i++) {
				    for (let j = i + 1; j < ranges.length; j++) {
				        if (this.hasOverlap(ranges[i], ranges[j])) {
				          this.$message.warning("三个时间段不能有交集!");
				          return
				        }
				    }
				}
			}
            this.$refs["formData"].validate(async (valid) => {
                if (valid) {                    
                    
                    const _formData = {
                        ...this.formData,
						showStartDate: _form.time1 && _form.time1 [0] || '',
						showEndDate: _form.time1 && _form.time1[1] || '',
                        firstShowStartDate: _form.time2 && _form.time2 [0] || '',
						firstShowEndDate: _form.time2 && _form.time2[1] || '',
						secondShowStartDate: _form.time3 && _form.time3 [0] || '',
						secondShowEndDate: _form.time3 && _form.time3[1] || '',							
                       // cityCodes: _form.cityCodes.toString(),
                        isBind:  _form.type === 4 || _form.type === 5 || _form.type === 7  || _form.type === 9 ? 0 : _form.isBind,
						//cityCodeAndNameVos: _form.cityType != 0 && ( _form.type === 4 || _form.type === 5 ) || _form.type === 7 || _form.type === 8 ? _form.cityCodeAndNameVos : [],
						cityCodes: _form.cityType != 0 && ( _form.type === 4 || _form.type === 5 ) || _form.type === 7 ? _form.cityCodes : '',
                        // imgPath: _form.type == 1 &&  _form.adType == 1 ?  "" : _form.imgPath,
                        bindIds: _form.bindIds.replaceAll('，',',')
                    }					
					_formData.provinceCodes = [];
					_formData.cityCodes  = [];
					_formData.cityCodeAndNameVos.map(item => {
						if (!_formData.provinceCodes.find(v => v == item[0]) && !item[1]) {
							_formData.provinceCodes.push(item[0]);
						}
						item[1] && _formData.cityCodes.push(item[1]);
					})
					
					_formData.provinceCodes = _formData.provinceCodes.toString();
					_formData.cityCodes = _formData.cityCodes.toString();
					// console.log(_formData)
					// return
					if( _formData.type == 7 &&  _formData.imgPath == '' && _formData.imgPathWap == '' ){
						 this.$message.warning("请至少上传一张广告图");
						 return
					}
					
					this.btnLoading = true;
                    const response = await this.$request({
                        url: "/advertising/save",
                        method: "POST",
                        data: {
                            ..._formData,
                        },
                    });
                    const {msg, state} = response.data;
                    this.btnLoading = false;
                    if (state != 1) return this.$message.error(msg);
                    this.$message.success('广告保存成功');
                    this.$router.go(-1);
                }
            });
        },
        //删除
        del() {
            const _msg = '确认删除该广告?';
            this.$confirm(_msg, '删除广告', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(async () => {
                const response = await this.$request({
                    url: "/advertising/delete",
                    method: "POST",
                    params: { id: this.id },
                });
                const { msg, state } = response.data;
                if (state != 1) return this.$message.error(msg);
                this.$message.success('广告删除成功');
                this.$router.go(-1);
            }).catch(() => { })
        },
    },
};
</script>

<style lang="scss" scoped>
</style>